import React, { useState } from 'react';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import EmployeeProcessService from '../services/EmployeeProcessService';
import LeaveProcessService from '../services/LeaveProcessService';
import { useLoading } from '../Utils/LoadingContext';

function LeaveBalanceUpload() {
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const { setLoading } = useLoading();

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const downloadExcel = (data, fileName = "LeaveBalanceResult.xlsx") => {
        if (!data || data.length === 0) return;

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Result");

        XLSX.writeFile(wb, fileName);
    };

    const handleUpload = async (e) => {
        e.preventDefault();

        if (!file) {
            toast.warning("Please select file");
            return;
        }

        if (!window.confirm("Upload Leave Balance Data?")) return;

        try {
            setLoading(true);
            setUploading(true);

            const formData = new FormData();
            formData.append("file", file);

            const response = await LeaveProcessService.setLeaveBalanceUpload(formData);

            if (response.success && response.data.statusCode === 200) {
                downloadExcel(response.data.result);
                toast.success("Upload successful");
            } else {
                toast.error(response.data.message || "Upload failed");
            }
        } catch (err) {
            toast.error("Upload failed");
        } finally {
            setUploading(false);
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleUpload} className="upload-form">
            <div className="row">
                <div className="col-12 mb-3 border-bottom pb-2">
                    <h4 className="text-primary">Leave Balance Upload</h4>
                    <button
                        type="button"
                        className="btn btn-outline-success"
                        onClick={async () => {
                           const success = await EmployeeProcessService.getTemplate("LeaveBalance.xlsx");
                            if (success) {
                                alert("Template downloaded successfully.", "success");
                            }
                        }}
                    >
                        Download Template
                    </button>
                </div>

                <div className="form-group col-md-4">
                    <label>Select File</label>
                    <input type="file" onChange={handleFileChange} />
                </div>

                <div className="form-group mt-4 col-md-2">
                    <button className="btn btn-primary" type="submit" disabled={uploading}>
                        {uploading ? "Uploading..." : "Upload"}
                    </button>
                </div>

            </div>
        </form>
    );
}

export default LeaveBalanceUpload;